export const ALL_LOCATIONS_VALUE = 'all';

export const allLocationsOption = {
    id: ALL_LOCATIONS_VALUE,
    value: ALL_LOCATIONS_VALUE,
    labelResource: 'INSIGHTS.DASHBOARD.ALL_LOCATIONS',
    name: 'location',
};
